import React from 'react';
import ServiceCard from '../../components/ServiceCard';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import ScienceIcon from '@mui/icons-material/Science';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import AnalyticsIcon from '@mui/icons-material/Analytics';

const IMG = {
  supplies: 'https://images.unsplash.com/photo-1583324113626-70df0f4deaab?auto=format&fit=crop&q=80&w=2670',
  pcr: '/images/shop/0.1ml-4-strips-PCR-tube-300x300.png',
  cube: '/images/electrosurgical/Cube-25-NIV-300x300.jpg',
  speculum: '/images/obgyn/Cusco-Vaginal-Speculum-Central-Screw-Extra-Small-300x300.jpg',
  mattress: '/images/home/Anti-decubitus-Mattress-Bubble-Type-300x300.jpg',
  leadcare: '/images/leadcare/LeadCare-II-Analyzer-Kit-300x300.jpg',
};

const SERVICES = [
  { title: 'Diagnostics & Medical Supplies', desc: 'Diagnostic kits, consumables, sharp containers, IV bags, urine bags and laryngeal masks.', icon: <MedicalServicesIcon />, img: IMG.supplies, category: 'all' },
  { title: 'Laboratory Equipment', desc: 'PCR tubes, centrifuge tubes, cryo vials, microbiology reagents, ELISA reagents and more.', icon: <ScienceIcon />, img: IMG.pcr, category: 'lab' },
  { title: 'Electrosurgical Equipment', desc: 'LEEP systems (CUBE 25 NIV), loop electrodes, ball electrodes and smoke evacuation tubing.', icon: <ElectricBoltIcon />, img: IMG.cube, category: 'electrosurgical' },
  { title: 'OB/GYN Instruments', desc: 'Vaginal speculums (Cusco, Graves, disposable), forceps, cervical dilators and pessaries.', icon: <FavoriteIcon />, img: IMG.speculum, category: 'obgyn' },
  { title: 'Hospital Furniture & Equipment', desc: 'Hospital beds, anti-decubitus mattresses, trolleys, ultrasound scanners and infusion systems.', icon: <LocalHospitalIcon />, img: IMG.mattress, category: 'all' },
  { title: 'LeadCare & Blood Testing', desc: 'LeadCare II blood lead analyzers, test kits, printers and accessories for point-of-care testing.', icon: <AnalyticsIcon />, img: IMG.leadcare, category: 'leadcare' },
];

const ServicesGrid: React.FC = () => (
  <section className="py-20 bg-light">
    <div className="container-main">
      <div className="text-center mb-14">
        <span className="section-label">Product Lines</span>
        <h2 className="section-heading mt-2">Our Core Service Categories</h2>
        <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
          All products are sourced directly from top manufacturers globally and come with CE certification and FDA approval.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {SERVICES.map(s => (
          <ServiceCard
            key={s.title}
            icon={s.icon}
            title={s.title}
            description={s.desc}
            link={s.category === 'all' ? '/shop' : `/shop?category=${s.category}`}
            backgroundImage={s.img}
          />
        ))}
      </div>
    </div>
  </section>
);

export default ServicesGrid;
